import {
    PMS_DIST_LOGIN_RESPONSE, PMS_DIST_LOGIN_FAIL, PMS_GENERATE_OTP_RESPONSE, RESET_FORGOT_PASSWORD_RESPONSE, RESET_FORGOT_PASSWORD_FAIL

} from '../types/pmsTypes';

const initialState = {
    pmsState: [],
    generateOtp: '',
    resetPasswordState: {}
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case PMS_DIST_LOGIN_RESPONSE:
            return { ...state, pmsState: action.payload }
        case PMS_GENERATE_OTP_RESPONSE:
            return { ...state, generateOtp: action.payload }
        case RESET_FORGOT_PASSWORD_RESPONSE:
            return { ...state, resetPasswordState: action.payload }
        case RESET_FORGOT_PASSWORD_FAIL:
            return { ...state, resetPasswordState: action.payload }

        default:
            return state
    }

}
